// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Mayotte from '../_raw/flag/icon_flag_mayotte.png';

export default () => <img src={Mayotte} alt="Mayotte" />;
